import * as React from 'react';
import Heading from 'components/text/Heading';
import Image from 'next/image';

interface Props {
  name: string;
  imageUrl: string;
}

const LOGO_SIZE = 150;

const ShopDetailsTitle: React.FC<Props> = ({ name, imageUrl }) => {
  return (
    <div className="flex flex-col-reverse items-start gap-2">
      <Heading className="w-fit" variant="h3" tag="h1">
        {name}
      </Heading>
      <Image
        className="max-h-9 h-9 object-contain w-auto max-w-[50%]"
        src={imageUrl}
        alt={`${name} image`}
        width={LOGO_SIZE}
        height={LOGO_SIZE}
      />
    </div>
  );
};

export default ShopDetailsTitle;
